export default __webpack_public_path__ + "static/media/bussiness-shop.e68fc6d1.svg";